import { render, staticRenderFns } from "./Name3DAnimation.vue?vue&type=template&id=efe84c7c&scoped=true"
import script from "./Name3DAnimation.vue?vue&type=script&lang=js"
export * from "./Name3DAnimation.vue?vue&type=script&lang=js"
import style0 from "./Name3DAnimation.vue?vue&type=style&index=0&id=efe84c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe84c7c",
  null
  
)

export default component.exports